// @flow
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import fidLogo from 'assets/img/fid/fid_logo_couleur_banniere.svg';
import type { FullUserType, UserFidType } from 'types/User';
import 'components/profile/fid.scss';

export type StateProps = {
  fid_page: string,
  userFid: UserFidType,
  userPref: FullUserType
};

export type DispatchProps = {
  postUserFid: (action: string, value: any, token: string, redirect?: string) => void
};

type Props = {
  doNotShowIfSubscribed?: boolean,
  classNamesAdded?: string
} & StateProps &
  DispatchProps;

class FidInscription extends PureComponent<Props> {
  props: Props;

  handleAddFid = (e: MouseEvent, id: number) => {
    const {
      postUserFid,
      userPref: { token }
    } = this.props;

    e.stopPropagation();
    e.preventDefault();

    const postUserFidAction = 'fid_subscribe';

    postUserFid(postUserFidAction, ``, token, '/tableau-de-bord/ma-fidelite');
  };

  handleDelFid = (e: MouseEvent, id: number) => {
    const {
      postUserFid,
      userPref: { token }
    } = this.props;

    e.stopPropagation();
    e.preventDefault();

    const postUserFidAction = 'fid_unsubscribe';

    postUserFid(postUserFidAction, ``, token);
  };

  handleDelFidRe = (e: MouseEvent, id: number) => {
    const {
      postUserFid,
      userPref: { token }
    } = this.props;

    e.stopPropagation();
    e.preventDefault();

    const postUserFidAction = 'fid_resubscribe';

    postUserFid(postUserFidAction, ``, token, '/tableau-de-bord/ma-fidelite');
  };

  render() {
    const {
      userFid: { fid },
      fid_page,
      doNotShowIfSubscribed
    } = this.props;

    /**
     * Ne pas afficher le bloc si programme activé et doNotShowIfSubscribed à true
     */
    if (fid && fid.data && fid.data.status && fid.data.status === 'enabled' && doNotShowIfSubscribed) {
      return null;
    }
    let className = this.props.classNamesAdded
      ? ` ${this.props.classNamesAdded} box box--white card card--profile card--form fid_inscription`
      : 'box box--white card card--profile card--form fid_inscription';

    if (fid && fid.data && fid.data.status && fid.data.status === 'enabled') {
      return (
        <div className={className}>
          <div className="logo">
            <img src={fidLogo} alt="Programme de fidélité" />
          </div>
          <div className="card__body">
            <div>
              <h3 className="card__title text-center">Bienvenue dans ton club de fidélité</h3>
              <p className="text-center">Profite de ses nombreux avantages :</p>
              <div className={'avantages mt-3'}>
                <div>
                  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      opacity="0.35"
                      d="M24.6917 16.0071C24.6917 17.1999 24.2339 17.9066 23.6321 17.9066L22.5593 22.5175C22.0404 24.8931 21.3601 25.5446 19.3934 25.5446H14.9672C13.1139 25.5446 12.0804 25.1036 11.2562 24.7478C10.637 24.4821 10.1486 24.2716 9.43339 24.2716H7.76758C7.76758 23.3044 8.45222 22.5175 9.29385 22.5175H15.0065C16.1621 22.5175 17.1912 21.6855 17.5837 20.4376L18.7916 16.5885C19.1841 15.3355 20.2219 14.4985 21.3863 14.4985H22.6989C23.6146 14.4935 24.6917 14.4885 24.6917 16.0071ZM18.3032 10.9802C18.6433 9.85256 19.485 7.57217 18.2465 6.92063C17.8148 6.6951 17.9718 6.9056 17.745 7.38673L14.7928 13.832C14.566 14.3081 14.8669 14.8945 15.3422 14.8945H16.2318C16.2318 14.8895 17.902 12.3084 18.3032 10.9802Z"
                      fill="#A6B7C7"
                    />
                    <path
                      d="M25.0403 16.008C25.0403 17.3863 24.5083 18.1029 23.9109 18.2733L22.8992 22.6136C22.3454 25.1646 21.5256 25.9415 19.3931 25.9415H14.967C13.0482 25.9415 11.9842 25.4854 11.1338 25.1195C10.5233 24.8589 10.0829 24.6685 9.43313 24.6685H7.76732C7.57544 24.6685 7.41846 24.488 7.41846 24.2675V18.544C7.41846 18.3235 7.57544 18.143 7.76732 18.143C7.95919 18.143 8.11618 18.3235 8.11618 18.544V23.8666H9.42877C10.205 23.8666 10.7457 24.0971 11.3693 24.3678C12.1717 24.7136 13.1703 25.1396 14.9626 25.1396H19.3931C20.3394 25.1396 20.9107 24.9792 21.2988 24.6083C21.5648 24.3527 21.7785 23.9718 21.966 23.3955H20.7406C20.5487 23.3955 20.3918 23.215 20.3918 22.9945C20.3918 22.774 20.5487 22.5936 20.7406 22.5936H22.1797C22.1928 22.5334 22.2058 22.4783 22.2189 22.4131V22.4081L22.5809 20.8494H21.1985C21.0066 20.8494 20.8496 20.669 20.8496 20.4485C20.8496 20.228 21.0066 20.0475 21.1985 20.0475H22.7727L23.1783 18.3034H21.7654C21.5735 18.3034 21.4165 18.123 21.4165 17.9025C21.4165 17.682 21.5735 17.5015 21.7654 17.5015H23.5533C23.5664 17.5015 23.5795 17.5015 23.5926 17.5065C23.6056 17.5065 23.6187 17.5015 23.6318 17.5015C24.0504 17.5015 24.3426 16.8851 24.3426 16.003C24.3426 15.3514 24.1202 15.156 23.9022 15.0507C23.5882 14.8954 23.1434 14.8954 22.7117 14.8954C22.7073 14.8954 22.7073 14.8954 22.703 14.8954H15.5208C15.3289 14.8954 15.1719 14.7149 15.1719 14.4944C15.1719 14.2739 15.3289 14.0935 15.5208 14.0935H22.7073C22.7117 14.0935 22.7117 14.0935 22.7161 14.0935C23.1957 14.0935 23.7365 14.0935 24.1813 14.314C24.7525 14.5997 25.0403 15.166 25.0403 16.008ZM7.76732 17.0354H9.42877C10.362 17.0354 10.7893 16.2135 11.5568 14.725C11.7618 14.329 12.0147 13.8379 12.3025 13.3267C12.8869 12.2942 13.4974 11.6778 14.0381 11.1365C14.9059 10.2644 15.7301 9.43746 16.4365 7.01674L16.4845 6.85636H17.1779C17.9018 6.85636 18.4905 7.53296 18.4905 8.35992C18.4905 10.2093 17.5093 11.9584 16.7723 13.1212C16.6589 13.3016 16.6938 13.5522 16.8464 13.6825C17.0034 13.8128 17.2215 13.7727 17.3349 13.5973C18.1285 12.3493 19.1882 10.4448 19.1882 8.36493C19.1882 7.09192 18.2855 6.05948 17.1779 6.05948H16.2316C16.0833 6.05948 15.9481 6.16974 15.9002 6.33513L15.7737 6.76615C15.1239 8.98139 14.4393 9.66801 13.5759 10.5401C13.0002 11.1164 12.3505 11.768 11.7182 12.8956C11.4216 13.4219 11.1644 13.9231 10.955 14.324C10.1657 15.8526 9.91282 16.2436 9.42441 16.2436H7.76732C7.57544 16.2436 7.41846 16.424 7.41846 16.6445C7.41846 16.865 7.57544 17.0354 7.76732 17.0354Z"
                      fill="white"
                    />
                    <circle cx="16.2295" cy="16" r="15.5" stroke="white" />
                  </svg>
                  <p>
                    Accède aux
                    <br />
                    <strong>préventes</strong>
                  </p>
                </div>
                <div>
                  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      opacity="0.35"
                      d="M24.0752 14.5311C24.0752 15.7239 21.0154 17.8041 20.4136 17.8041L20.7697 21.6395C20.2508 24.0152 21.3489 22.2193 19.3822 22.2193L16.1537 20.8368C14.3004 20.8368 13.7494 23.4671 12.9252 23.1113C12.306 22.8456 12.3846 22.9706 11.6694 22.9706L11.6697 21.6395C11.6697 20.6723 11.7697 20.8368 12.6113 20.8368L16.1537 19.1421C17.3093 19.1421 18.1826 20.9698 18.5751 19.7218L19.8306 15.5296C20.2231 14.2767 19.2492 13.5673 20.4136 13.5673L22.0278 13.8349C22.9436 13.8299 24.0752 13.0125 24.0752 14.5311Z"
                      fill="#A6B7C7"
                    />
                    <g clipPath="url(#clip0_1481_13617)">
                      <path
                        d="M12.3326 22.1976L16.2306 19.8459L20.1286 22.2226L19.0858 17.7693L22.5121 14.7671L17.9934 14.3668L16.2306 10.1636L14.4678 14.3417L9.94905 14.742L13.3753 17.7443L12.3326 22.1976ZM16.2306 21.5972L11.6125 24.3993C11.4785 24.4843 11.3394 24.5194 11.1905 24.5094C11.0415 24.4994 10.9074 24.4543 10.7932 24.3693C10.679 24.2842 10.5896 24.1791 10.535 24.044C10.4754 23.9089 10.4655 23.7588 10.5002 23.5937L11.7168 18.2897L7.64002 14.717C7.50594 14.6019 7.42649 14.4718 7.40663 14.3317C7.3818 14.1916 7.38677 14.0515 7.42153 13.9164C7.45629 13.7813 7.53077 13.6712 7.64498 13.5812C7.75919 13.4911 7.9032 13.4361 8.06706 13.416L13.4548 12.9407L15.5354 7.93692C15.6 7.78681 15.6993 7.67673 15.8333 7.59667C15.9674 7.52161 16.0965 7.48158 16.2306 7.48158C16.3647 7.48158 16.4938 7.52161 16.6278 7.59667C16.7619 7.67173 16.8612 7.78681 16.9258 7.93692L19.0114 12.9407L24.3991 13.416C24.563 13.431 24.707 13.4861 24.8212 13.5812C24.9354 13.6762 25.0099 13.7863 25.0446 13.9164C25.0794 14.0515 25.0844 14.1866 25.0595 14.3317C25.0347 14.4718 24.9552 14.6019 24.8261 14.717L20.7543 18.2947L21.9709 23.5987C22.0057 23.7638 21.9908 23.9139 21.9312 24.049C21.8716 24.1841 21.7872 24.2892 21.668 24.3743C21.5538 24.4593 21.4197 24.5044 21.2707 24.5144C21.1218 24.5244 20.9827 24.4843 20.8487 24.4043L16.2306 21.6022V21.5972Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.1054 22.5099L13.2088 17.7978L9.58626 14.6236L14.3647 14.2003L16.231 9.77675L18.0967 14.2253L22.8749 14.6486L19.2524 17.8228L20.3563 22.5372L16.2302 20.0213L12.1054 22.5099ZM16.2306 19.8459L20.1286 22.2226L19.0858 17.7693L22.5121 14.7671L17.9934 14.3668L16.2306 10.1636L14.4678 14.3417L9.94905 14.742L13.3753 17.7443L12.3326 22.1976L16.2306 19.8459ZM16.3806 21.5177V21.3307L11.5347 24.271L11.5322 24.2726C11.4243 24.341 11.3168 24.3675 11.2005 24.3597C11.0764 24.3514 10.9709 24.3146 10.8828 24.249C10.7868 24.1775 10.7167 24.0933 10.6741 23.9878L10.6722 23.9835C10.6279 23.8829 10.6174 23.7661 10.6467 23.6258C10.6468 23.6254 10.6469 23.625 10.647 23.6246L11.883 18.2359L7.73888 14.6042L7.73772 14.6032C7.62366 14.5053 7.56864 14.4059 7.55515 14.3107L7.55433 14.3056C7.53315 14.1861 7.53751 14.0676 7.5668 13.9538C7.59274 13.853 7.64739 13.7703 7.73787 13.6989C7.82629 13.6292 7.94224 13.5828 8.08283 13.5652L13.5584 13.0821L15.6732 7.99618C15.6731 7.99646 15.6733 7.9959 15.6732 7.99618C15.7247 7.87686 15.802 7.79051 15.9085 7.72652C16.0254 7.66135 16.1288 7.63158 16.2306 7.63158C16.3329 7.63158 16.4369 7.66167 16.5546 7.72756C16.6568 7.78477 16.7348 7.87288 16.7877 7.99545C16.7876 7.9952 16.7878 7.99569 16.7877 7.99545L18.9078 13.0821L24.3854 13.5654C24.3853 13.5654 24.3855 13.5654 24.3854 13.5654C24.5236 13.5781 24.6378 13.6237 24.7252 13.6964C24.8188 13.7744 24.8738 13.8587 24.8995 13.9544C24.9286 14.0677 24.9331 14.1811 24.9118 14.306C24.894 14.4055 24.8363 14.5069 24.7267 14.6048C24.7265 14.6049 24.7268 14.6047 24.7267 14.6048L20.5881 18.2411L21.8241 23.6296C21.8242 23.63 21.8243 23.6304 21.8244 23.6308C21.8529 23.7675 21.8396 23.8849 21.7939 23.9885C21.7449 24.0996 21.6775 24.1832 21.5808 24.2522L21.5784 24.254C21.4903 24.3196 21.3848 24.3564 21.2607 24.3647C21.1474 24.3723 21.0385 24.3429 20.926 24.2757C20.9258 24.2757 20.9261 24.2758 20.926 24.2757L16.3806 21.5177ZM20.8487 24.4043L16.2306 21.6022V21.5972L11.6125 24.3993C11.4785 24.4843 11.3394 24.5194 11.1905 24.5094C11.0415 24.4994 10.9074 24.4543 10.7932 24.3693C10.679 24.2842 10.5896 24.1791 10.535 24.044C10.4754 23.9089 10.4655 23.7588 10.5002 23.5937L11.7168 18.2897L7.64002 14.717C7.50594 14.6019 7.42649 14.4718 7.40663 14.3317C7.3818 14.1916 7.38677 14.0515 7.42153 13.9164C7.45629 13.7813 7.53077 13.6712 7.64498 13.5812C7.75919 13.4911 7.9032 13.4361 8.06706 13.416L13.4548 12.9407L15.5354 7.93692C15.6 7.78681 15.6993 7.67673 15.8333 7.59667C15.9674 7.52161 16.0965 7.48158 16.2306 7.48158C16.3647 7.48158 16.4938 7.52161 16.6278 7.59667C16.7619 7.67173 16.8612 7.78681 16.9258 7.93692L19.0114 12.9407L24.3991 13.416C24.563 13.431 24.707 13.4861 24.8212 13.5812C24.9354 13.6762 25.0099 13.7863 25.0446 13.9164C25.0794 14.0515 25.0844 14.1866 25.0595 14.3317C25.0347 14.4718 24.9552 14.6019 24.8261 14.717L20.7543 18.2947L21.9709 23.5987C22.0057 23.7638 21.9908 23.9139 21.9312 24.049C21.8716 24.1841 21.7872 24.2892 21.668 24.3743C21.5538 24.4593 21.4197 24.5044 21.2707 24.5144C21.1218 24.5244 20.9827 24.4843 20.8487 24.4043Z"
                        fill="white"
                      />
                    </g>
                    <circle cx="16.2295" cy="16" r="15.5" stroke="white" />
                    <defs>
                      <clipPath id="clip0_1481_13617">
                        <rect width="17.6827" height="17.0278" fill="white" transform="translate(7.3877 7.48564)" />
                      </clipPath>
                    </defs>
                  </svg>
                  <p>
                    Profite des
                    <br />
                    <strong>ventes privées</strong>
                  </p>
                </div>
                <div>
                  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="16.2295" cy="16" r="15.5" stroke="white" />
                    <path
                      opacity="0.3"
                      d="M26.4569 12.1518C26.4569 13.6151 25.9291 15.0273 24.98 16.0813L16.5072 25.4445C15.2294 24.0324 15.2294 21.7351 16.5072 20.3229L21.9659 14.2905C22.9197 13.2365 23.4429 11.8244 23.4429 10.361C23.4429 10.0643 23.429 9.77775 23.3734 9.51169C23.2808 8.81584 23.0678 8.15581 22.7576 7.57253C22.5724 7.22461 22.8873 6.81529 23.2252 6.95855C23.8873 7.23996 24.48 7.67486 24.9754 8.22233C25.7161 9.04097 26.2254 10.1103 26.3829 11.3025C26.443 11.5685 26.4569 11.8499 26.4569 12.1518Z"
                      fill="#A6B7C7"
                    />
                    <path
                      d="M6.7099 11.3844C6.65434 11.6351 6.64971 11.9217 6.64971 12.1366C6.64971 13.5078 7.13586 14.7971 8.02017 15.7744L10.8954 18.9518C11.0389 19.1104 11.0389 19.3713 10.8954 19.5299C10.8213 19.6118 10.7287 19.6476 10.6315 19.6476C10.5389 19.6476 10.4416 19.6067 10.3675 19.5299L7.49236 16.3526C6.46915 15.2269 5.9043 13.7278 5.9043 12.1417C5.9043 11.8858 5.91356 11.5482 5.98301 11.2156C6.14968 9.96715 6.67286 8.83128 7.49236 7.92054C8.51558 6.78979 9.87214 6.16557 11.3074 6.16557C12.7427 6.16557 14.0993 6.78979 15.1225 7.92054L16.4883 9.42991C16.6318 9.58853 16.6318 9.84947 16.4883 10.0081C16.3448 10.1667 16.1087 10.1667 15.9651 10.0081L14.5993 8.49871C13.715 7.52145 12.5482 6.98422 11.3074 6.98422C10.0666 6.98422 8.89986 7.52145 8.01554 8.49871C7.30253 9.28665 6.85343 10.269 6.71453 11.3486C6.71453 11.364 6.7099 11.3742 6.7099 11.3844ZM26.4751 11.2156C26.3084 9.96715 25.7852 8.83128 24.9657 7.92054C23.9425 6.78979 22.5859 6.16557 21.1506 6.16557C19.7154 6.16557 18.3588 6.78979 17.3356 7.92054L16.8726 8.43219C16.7291 8.5908 16.7291 8.85175 16.8726 9.01036C17.0161 9.16897 17.2522 9.16897 17.3958 9.01036L17.8588 8.49871C18.7431 7.52145 19.9098 6.98422 21.1506 6.98422C22.3915 6.98422 23.5582 7.52145 24.4425 8.49871C25.1555 9.28665 25.6046 10.269 25.7435 11.3486C25.7435 11.3588 25.7482 11.3742 25.7482 11.3844C25.8037 11.6403 25.8083 11.9217 25.8083 12.1366C25.8083 13.5078 25.3222 14.7971 24.4379 15.7744L16.229 24.8511L12.7751 21.0342C12.6316 20.8756 12.3955 20.8756 12.2519 21.0342C12.1084 21.1928 12.1084 21.4537 12.2519 21.6123L15.9651 25.7158C16.0346 25.7925 16.1272 25.8335 16.229 25.8335C16.3309 25.8335 16.4235 25.7925 16.4929 25.7158L24.9657 16.3526C25.9889 15.2269 26.5538 13.7278 26.5538 12.1417C26.5538 11.8807 26.5445 11.543 26.4751 11.2156Z"
                      fill="white"
                    />
                  </svg>
                  <p>
                    Consulte des
                    <br />
                    <strong>contenus exclusifs</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className={className}>
        <div className="logo">
          <img src={fidLogo} alt="Programme de fidélité" />
        </div>
        <div className="card__body">
          <div>
            <h3 className="card__title">Adhère à ton nouveau programme de fidélité Club France Rugby</h3>
            <p>Plus tu participes, plus tu gagnes des avantages et des récompenses !</p>
            <div className={'buttons mt-3'}>
              {(!fid || !fid.data || !fid.data.status) && (
                <button className="btn btn--primary" type="button" onClick={this.handleAddFid}>
                  Adhérer au programme
                </button>
              )}

              {fid && fid.data && fid.data.status && fid.data.status !== 'enabled' && (
                <button className="btn btn--primary" type="button" onClick={this.handleDelFidRe}>
                  Réactiver mon programme de fidélité
                </button>
              )}
              {/*fid && fid.data && fid.data.status && fid.data.status === 'enabled' && (
              <button className="btn btn--primary" type="button" onClick={this.handleDelFid}>
                Ne plus participer au programme
              </button>
            )*/}
              {fid_page && (
                <Link to={fid_page} className={'btn btn--white'}>
                  Fonctionnement des points et badges
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FidInscription;
